import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import Header from '../components/Header'
import Footer from '../components/Footer'
import gsap from 'gsap'
import SplitType from 'split-type'
import './NotFound.css'

const animateLines = (selector: string, delay = 0) => {
  const elements = document.querySelectorAll(selector)
  if (elements.length === 0) return

  const split = new SplitType(selector, { types: 'lines' })
  document.querySelectorAll(`${selector} .line`).forEach(line => {
    if (!line.querySelector('.line-inner')) {
      const span = document.createElement('span')
      span.className = 'line-inner'
      span.innerHTML = line.innerHTML
      line.innerHTML = ''
      line.appendChild(span)
    }
  })
  
  gsap.set(`${selector} .line-inner`, { 
    yPercent: 80,
    opacity: 0,
    visibility: 'hidden'
  })
  
  gsap.to(`${selector} .line-inner`, {
    yPercent: 0,
    opacity: 1,
    visibility: 'visible',
    duration: 1,
    ease: 'cubic-bezier(0.23, 1, 0.32, 1)',
    stagger: 0.08,
    delay,
  })
}

function NotFound() {
  useEffect(() => {
    // Animate on mount
    animateLines('.not-found-title')
    animateLines('.not-found-subtitle', 0.2)
    animateLines('.not-found-description', 0.4)
    
    // Animate the link button
    gsap.fromTo('.not-found-link', 
      { 
        opacity: 0, 
        y: 20 
      }, 
      { 
        opacity: 1, 
        y: 0, 
        duration: 0.8, 
        ease: 'cubic-bezier(0.23, 1, 0.32, 1)', 
        delay: 0.6 
      }
    )
  }, [])

  return (
    <div className="not-found-page">
      <Header />
      
      <main className="not-found-content">
        <div className="not-found-container">
          <h1 className="not-found-title">404</h1>
          <h2 className="not-found-subtitle">Page Not Found</h2>
          <p className="not-found-description">
            The page you're looking for doesn't exist or has been moved.
          </p>
          
          <Link to="/" className="not-found-link">
            Back to Home
          </Link>
        </div>
      </main>
      
      <Footer />
    </div>
  )
}

export default NotFound 